module.exports = {"371326001":"平邑街道","371326101":"仲村镇","371326102":"武台镇","371326103":"保太镇","371326104":"柏林镇","371326105":"卞桥镇","371326106":"地方镇","371326107":"铜石镇","371326108":"温水镇","371326109":"流峪镇","371326110":"郑城镇","371326111":"白彦镇","371326112":"临涧镇","371326113":"丰阳镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/371326.json
// module id = 1583
// module chunks = 0